import styled from "styled-components";
import { IconTextPair } from "./base.styles";
export const ConfirmationContent = styled.div `
    ${IconTextPair}
    align-self: center;
    justify-content: center;
    width: 100%;
`;
